<div class="overall-grade-breakdown-container" [class.expanded-layout]="isExpanded">
  <!-- Header Section (can be hidden when used in other contexts) -->
  <div class="breakdown-header" *ngIf="showHeader">
    <div class="header-content">
      <div class="title-section">
        <span class="breakdown-title">Overall Grade Component Breakdown</span>
      </div>
      <svg class="arrow-icon" width="31" height="32" viewBox="0 0 31 32" fill="none">
        <path d="M15.6913 13.1082L22.2814 19.6982L24.1639 17.8157L15.6913 9.34315L7.21875 17.8157L9.10125 19.6982L15.6913 13.1082Z" fill="white"/>
      </svg>
    </div>
  </div>

  <!-- Chart and Legend Section -->
  <div class="chart-content" [class.expanded-layout]="isExpanded">
    <!-- Pie Chart -->
    <div class="pie-chart-container">
      <svg class="pie-chart" width="214" height="214" viewBox="0 0 214 214" fill="none">
        <path 
          *ngFor="let item of legendItems; let i = index" 
          [attr.d]="getSegmentPath(i)" 
          [attr.fill]="getSegmentColor(i)"/>
      </svg>
    </div>

    <!-- Legend -->
    <div class="chart-legend" [class.expanded-layout]="isExpanded">
      <div
        class="legend-item"
        *ngFor="let item of legendItems">
        <svg class="legend-color" width="6" height="6" viewBox="0 0 6 6" fill="none">
          <circle cx="3" cy="3" r="2.5" [attr.fill]="item.color"/>
        </svg>
        <span class="legend-label">{{ item.name }}</span>
      </div>
    </div>
  </div>
</div>
